import { createTheme } from '@mui/material/styles'
import { baseTheme } from './baseTheme'

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    background: {
      default: '#000'
    },
    primary: {
      main: '#9a3718',
      light: '#d79d5d',
      dark: '#010101'
    },
    secondary: {
      main: '#f1f1f1',
      light: '#7f7f7f',
      dark: '#2e3b34'
    },
    success: {
      main: '#103778',
      light: '#0593a2',
      dark: '#151f30'
    }
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        enableColorOnDark: true
      }
    }
  }
})
